import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import HeadingAndSupportingTextWithActions from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import ImageAndContent from 'src/app/molecules/ImageAndContent/ImageAndContent';
import { IStaticContentfulImages } from 'src/types/contentful';

const GettingStartedImageAndContent = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      featuredImage: contentfulAsset(contentful_id: { eq: "AgBb8yROBLjbJBT4i7MYn" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1300)
      }
    }
  `);

  return (
    <Stack
      margin={['spacing-none', 'spacing-auto']}
      justify='center'
      align='center'
    >
      <ImageAndContent
        image={{
          imageProps: {
            image: images.featuredImage.gatsbyImageData,
            alt: 'What do I build first?',
          },
          maxWidth: 650,
          radius: 'radius-2xl',
        }}
        contentPosition='left'
        content={
          <Stack
            padding={['spacing-none', 'spacing-4xl']}
            paddingMd='spacing-none'
            direction='column'
            gap='spacing-4xl'
          >
            <HeadingAndSupportingTextWithActions
              maxWidth='width-2xl'
              gap='spacing-3xl'
              direction='column'
              justify='flex-start'
              align='flex-start'
              heading={{
                type: 'heading',
                text: 'What do I build first?',
                size: 'lg',
                letterSpacing: -1,
                fontWeight: 'font-weight-semibold',
              }}
              subHeading={{
                text: 'Getting Started',
                size: 'md',
                type: 'paragraph',
                color: 'text-brand-secondary',
                fontWeight: 'font-weight-semibold',
              }}
              subHeadingGap='spacing-lg'
              supportingText={{
                type: 'paragraph',
                size: 'xl',
                color: 'text-tertiary',
                children: (
                  <Stack
                    direction='column'
                    gap='spacing-lg'
                    as='span'
                  >
                    <Typography
                      as='span'
                      text='Start with a paid challenge — without the promise of more.'
                    />
                    <Typography
                      as='span'
                      text="Charge $19-$49 for a 7 or 30-day challenge with one goal your members can hit. With just 10 people, you'll know if your idea works."
                    />
                    <Typography
                      as='span'
                      text='91% of our top earners started this way.'
                    />
                  </Stack>
                ),
              }}
              actions={
                <Stack marginTop='spacing-4xl'>
                  <Button
                    variant='primary'
                    size='xl'
                    href='https://cohost.mn.co/?plan=free-trial'
                  >
                    Start Your Free Trial
                  </Button>
                </Stack>
              }
            />
          </Stack>
        }
      />
    </Stack>
  );
};

export default GettingStartedImageAndContent;
